let origin = window.ORIGIN;
//创业导师列表
const getTeacherListUrl = `${origin}/gateway/hc-business/miniapi/advisor/getList`;

// 服务人数加一
const addCountURL = `${origin}/gateway/hc-business/miniapi/advisor/addServeCount`;

export { getTeacherListUrl, addCountURL };
